import React from 'react';


import './BookingWidget.css';

function BookingWidget() {
    return (
       <div>
           {/* <div class="col-md-4 widget">
                <div id="book-now-widget">
                    <div id="BEx4IDaY3bWD">
                        <div id="BEx4IDaY3bWR" class="BEx4ZXaY3bWR"></div>
                        <input type ="hidden" value="vNH542fVOcdncZm7B5k3gw" id="BEx4ZXaPkNmGuid" />
                        <input type ="hidden" value="pNK5mxe3MVWnihkUfCH4gg" id="BEx4ZYaLkProGuid" />
                    </div>
                </div>
           </div> */}
           <div class="col-md-4 widget">
            <div id="book-now-widget">
                <div id="BEx4IDaY3bWD">
                    <div id="BEx4IDaY3bWR" class="BEx4ZXaY3bWR"></div>
                        <input type ="hidden" value="FrmOnne118jtpxNpFLSXTA" id="BEx4ZXaPkNmGuid" />
                        <input type ="hidden" value="hahnewYRURcxpWB0cjHizA" id="BEx4ZYaLkProGuid" />
                    </div>	
                </div>
            </div>	
       </div>
    )
}

export default BookingWidget
